module.exports = __webpack_public_path__ + "img/Satisfaction@2x.6144ae41.png";